/**
 * Created by dennis on 27/07/2015.
 */
import './rt-component-demo/rt-demo';
import './view-component-demo/view-demo';
import './directive-component-demo/directive-demo';



/** WEBPACK FOOTER **
 ** c:/Users/den/Desktop/demo-app/src/app/components/components.js
 **/